
/* eslint-disable */
// @ts-nocheck
// @ts-ignore



export const enum ExternalChannel {
  CHUnknown = 0,
  CHNoknok = 1,
  CHShanxian = 2,
  CHZhushou = 3,
  CHJiasuqi = 4,
  CHZSNizhan = 3001,
  CHZSTXYouxi = 3002,
  CHZSTiandao = 3003,
  CHZSXuanwuShidai = 3004,
  CHZSQQXuanwu = 3005,
  CHZSDNF = 3006,
  CHZSQQFeiche = 3007,
  CHZSCF = 3008,
}

export const enum ExternalChannelZhushouRange {
  ZSChannelUnknown = 0,
  ZSChannelBegin = 3001,
  ZSChannelEnd = 4999,
}
